
import { Button } from '@/components/ui/button';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Bell } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

interface NotificationFiltersProps {
  filter: 'all' | 'unread' | 'read';
  setFilter: (filter: 'all' | 'unread' | 'read') => void;
  onMarkAllAsRead: () => void;
  unreadCount: number;
}

export function NotificationFilters({ 
  filter, 
  setFilter, 
  onMarkAllAsRead,
  unreadCount 
}: NotificationFiltersProps) {
  return (
    <div className="flex justify-between items-center">
      <Tabs value={filter} onValueChange={(value) => setFilter(value as any)}>
        <TabsList>
          <TabsTrigger value="all">All</TabsTrigger>
          <TabsTrigger value="unread" className="flex items-center gap-2">
            Unread
            {unreadCount > 0 && (
              <Badge variant="secondary" className="ml-1 h-5 px-2">
                {unreadCount}
              </Badge>
            )}
          </TabsTrigger>
          <TabsTrigger value="read">Read</TabsTrigger>
        </TabsList>
      </Tabs>
      
      <Button 
        variant="outline" 
        onClick={onMarkAllAsRead}
        disabled={unreadCount === 0}
      >
        <Bell className="mr-2 h-4 w-4" />
        Mark all as read
      </Button>
    </div>
  );
}
